import React from 'react';
interface RubricProps {
  index: string;
  title: string;
  count?: string;
  /** Condensed mode: tighter margins/type for denser CV pages. */
  compact?: boolean;
}
/** A numbered section header with a hairline and a mono index — the editorial spine of the doc. */
export function Rubric({
  index,
  title,
  count,
  compact = false
}: RubricProps) {
  return <div className={`keep-with-next flex items-baseline gap-4 border-b border-[var(--ink)] ${compact ? 'mb-3 pb-1.5' : 'mb-6 pb-2.5'}`} data-id="element-178" data-mp="2su4gf846wkde">
      <span className="font-mono text-[11px] tabular-nums text-[var(--accent)]" data-id="element-179" data-mp="2jvssjdupk0on">
        {index}
      </span>
      <h2 className={`flex-1 font-display font-normal tracking-tight text-[var(--ink)] ${compact ? 'text-[18px]' : 'text-[22px]'}`} data-id="element-180" data-mp="25wt2q2vglfqw">
        {title}
      </h2>
      {count && <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--ink-faint)]" data-id="element-181" data-mp="45g0xmosfnz2">
          {count}
        </span>}
    </div>;
}